/*
calculator
AT
10.06.21
*/

import Calculator from './calculator.svelte'

const
calculator = new Calculator({
	target: document.querySelector('#calculator'),
	props: { }
})

export default { calculator }